import axios from 'axios';
import MainURL from '../MainURL';

export type AdminInquiry = {
  id: number;
  name: string;
  company: string | null;
  email: string;
  phone: string;
  category: string | null;
  budget: string | null;
  planning_status: string | null;
  message: string;
  created_at?: string;
};

type ApiErrorBody = {
  ok?: boolean;
  error?: { code?: string; message?: string };
  message?: string;
};

const API_BASE = `${MainURL}/api/admin/inquiry`;

function getErrorMessage(err: unknown, fallback: string): string {
  if (axios.isAxiosError(err)) {
    const body = err.response?.data as ApiErrorBody | undefined;
    if (body?.error?.message) return body.error.message;
    if (typeof body?.message === 'string') return body.message;
  }
  return fallback;
}

export type FetchInquiryListOptions = {
  q?: string;
};

export async function fetchInquiryList(options?: FetchInquiryListOptions) {
  try {
    const params: FetchInquiryListOptions = {};
    if (options?.q) params.q = options.q;

    const res = await axios.get<{ ok: boolean; data?: AdminInquiry[] }>(`${API_BASE}/list`, {
      params: Object.keys(params).length ? params : undefined,
    });
    if (!res.data?.ok || !Array.isArray(res.data.data)) {
      throw new Error('문의 목록 응답 형식이 올바르지 않습니다.');
    }
    return res.data.data;
  } catch (err) {
    throw new Error(getErrorMessage(err, '문의 목록을 불러오지 못했습니다.'));
  }
}

export async function deleteInquiry(id: number) {
  try {
    const res = await axios.delete<{ ok: boolean }>(`${API_BASE}/${id}`);
    if (!res.data?.ok) {
      throw new Error('문의 삭제 응답 형식이 올바르지 않습니다.');
    }
  } catch (err) {
    throw new Error(getErrorMessage(err, '문의 삭제에 실패했습니다.'));
  }
}
